import {SP_TOKEN_WEIGHT, DECIMAL} from '../config';
export const getScore = (spToken, favours) => {
	// Cancel ######
	return (spToken / DECIMAL * SP_TOKEN_WEIGHT + favours * (1 - SP_TOKEN_WEIGHT)) * 1000;
}